import calendario_verde from 'assets/img/calendario_verde.png';
import calendario_amarilla from 'assets/img/calendario_amarilla.png';
import calendario_rojo from 'assets/img/calendario_rojo.png';
import MyGuestsButton from "./MyGuestsButton";
import { useWindowSize } from 'hooks';
import {useState} from 'react';
import styles from './styles.module.scss';

const MyGuestsStatistics = ({ estadisticainvitados , botoninvitados }) => {
    const [, { isMobile }] = useWindowSize();
    const [showDetail, setShowDetail] = useState(false)
    return (
        <div>
            {estadisticainvitados?.data?.items?.envio > 0 ? (
                <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ textAlign: 'center' }}>
                        <img src={calendario_verde} style={{ width: '40px', height: '40px' }} /><br />
                        <b>{estadisticainvitados?.data?.items?.confirmados}</b><br />
                        confirmados
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <img src={calendario_amarilla} style={{ width: '40px', height: '40px' }} /><br />
                        <b>{estadisticainvitados?.data?.items?.pendientes}</b><br />
                        pendientes
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <img src={calendario_rojo} style={{ width: '40px', height: '40px' }} /><br />
                        <b>{estadisticainvitados?.data?.items?.cancleados}</b><br />
                        cancleados
                    </div>


                </div>
                {isMobile && (
                    <>
                        <br></br>
                        {!showDetail && (
                        <div className={styles.rightAlign}>
                            <a style={{ cursor: 'pointer' }} className={styles.blueLink} onClick={() => setShowDetail(!showDetail)}>Ver detalle</a>
                        </div>
                        )}
                        {showDetail && <MyGuestsButton botoninvitados={botoninvitados} /> }
                        
                    </>
                )}

                </>
            ) : (
                <>
                    Aún no has enviado tu invitación, aquí aparecerá<br />la confirmación de tus invitados.
                </>
            )}
        </div>

    );
}

export default MyGuestsStatistics;